import React, {useMemo} from "react";

import EmailPreviewPage from "../../Templates/EmailPreviewPage";
import {useQuotes} from "../QuotesContext";


const QuotePreview = () => {
    const {selectedQuote: quote, quotePreviewDialog, updateEmailMessage} = useQuotes();

    const title = `Preventivo ${quote.surname || ""} ${quote.name || ""}`;
    const quoteTemplateVariables = useMemo(
        () => ({quote_id: quote.id}),
        [quote.id]
    )

    const handleSend = (emailMessage) => {
        updateEmailMessage(emailMessage);
    }

    return <>
        {
            quote.id && <EmailPreviewPage title={title}
                                          type="Templates::QuoteTemplate"
                                          templateVariables={quoteTemplateVariables}
                                          locale={quote.language}
                                          onClose={quotePreviewDialog.close}
                                          onSend={handleSend}
            />
        }
    </>
}

export default QuotePreview;